import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FrameContainer from 'components/consumer/FrameContainer';
import OrderLookupForm from './components/OrderLookupForm';
import OrderIssueForm from './components/OrderIssueForm';
import OrderIssueSuccess from './components/OrderIssueSuccess';

const WarrantyFormS3 = ({ isAdmin }) => {
  const [step, updateStep] = useState('order_lookup_form');
  const [orderLookInfo, updateOrderLookupInfo] = useState(null);
  const [orderInfo, updateOrderInfo] = useState(null);

  useEffect(() => {
    if (step === 'order_lookup_form' && orderInfo) {
      updateStep('order_issue_form');
    } else if (step === 'order_issue_form' && !orderInfo && !orderLookInfo) {
      updateStep('order_lookup_form');
    }
  }, [orderInfo, orderLookInfo, step]);
  if (isAdmin) {
    return (
      <div>
        WarrantyForm Placeholder for Variant Builder. <br />
        The component will display correctly in Consumer
      </div>
    );
  }
  return (
    <FrameContainer>
      <div>
        <div>
          {step === 'order_lookup_form' && (
            <OrderLookupForm
              actions={{ updateOrderInfo, updateOrderLookupInfo }}
            />
          )}
          {step === 'order_issue_form' && (
            <OrderIssueForm
              actions={{
                updateStep,
                updateOrderInfo,
                updateOrderLookupInfo,
              }}
              state={{
                step,
                orderLookInfo,
                orderInfo,
              }}
            />
          )}
          {step === 'order_issue_success' && <OrderIssueSuccess />}
        </div>
      </div>
    </FrameContainer>
  );
};

WarrantyFormS3.propTypes = {
  isAdmin: PropTypes.bool,
};

export default WarrantyFormS3;
